import React from 'react'
import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'

const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: 'transparent',
  borderColor: 'white',
  borderWidth: 4,
  borderRadius: 10,
}))

const DownloadBrandsButton = (props) => (
  <ColorButton { ...props } size='large' variant='outlined'>Download Brands</ColorButton>
)

export default DownloadBrandsButton

